import { useState } from "react";
import placeholderImage1 from "../../../images/placeholder.svg";
import placeholderImage2 from "../../../images/wv_image.png";
import { useEffect } from "react";
import fallbackImg from "../../../images/error-red-icon.svg";
import { useTranslation } from "react-i18next";

function ImageCheck(props) {
    const [imageSrc, setimageSrc] = useState(props.imageUrl);
    const [imageError, setImageError] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        if(!props?.imageUrl){
            onImageInvalid();
        }
    }, []);

    const onImageInvalid =()=> {
        if (props.showFallback) {
            setImageError(true);
          } else {
            props.placeholderImage === 1
              ? setimageSrc(placeholderImage1)
              : setimageSrc(placeholderImage2);
            // setImageError(true);
          }
     }
    
     useEffect(() => {
        props?.imageUrl && setimageSrc(props?.imageUrl)
    }, [props?.imageUrl]);
    
    return ( 
      <>
      {imageError ? ( //from : below code for image error handling
        <div
          className="fallback-div-image"
        >
          <img
            src={fallbackImg}
            alt={imageSrc}
            width={"35px"}
            style={{ border: "none" , objectFit: "contain", width:"50px", height:"50px", margin:"2%"}}
          />
          <h3 style={{ color: "black", fontSize: "14px", marginBottom: "0" }}>
            {t("MediaLoadingError")}
          </h3>
          <p style={{ color: "black", fontSize: "12px" }}>
          {t("TryLater")}
          </p>
        </div>
      ) : (
        //To
        <img
          src={imageSrc}
          style={props?.style && props?.style}
          className={props?.className && props?.className}
          onError={onImageInvalid}
          alt=""
        />
      )}
    </>
     );
}

export default ImageCheck;
